import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {hideMessage} from '../../../Store/Actions';
import NotificationService from '../../../Services/Common/notification';
import {Spin} from 'antd';

// Waiting-list registration messages stay open until the user closes them,
// so they can't be missed (regular and sponsor registration).
const WAITING_LIST_MESSAGE_PATTERN =
  /added to the waiting list|already on the waiting list/i;

const isWaitingListMessage = (text) =>
  typeof text === 'string' && WAITING_LIST_MESSAGE_PATTERN.test(text);

const getNotificationDuration = (text) =>
  isWaitingListMessage(text) ? 0 : undefined;

const AppInfoView = () => {
  const {loading, error, displayMessage} = useSelector(({common}) => common);
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      NotificationService.error('Error', error, getNotificationDuration(error));
      dispatch(hideMessage());
    }
  }, [error]);

  useEffect(() => {
    if (displayMessage) {
      if (isWaitingListMessage(displayMessage)) {
        NotificationService.pending('Added to Waiting List', displayMessage, 0);
      } else {
        NotificationService.success('Success', displayMessage);
      }
      dispatch(hideMessage());
    }
  }, [displayMessage]);

  return <>{loading ? <Spin prefixCls='pbss-loder' /> : null}</>;
};

export default AppInfoView;
